// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-employee-select {
  margin: 5px 0;
  display: flex;
  flex-direction: column-reverse;
  position: relative;
}
.new-employee-select label {
  font-size: 14px;
  font-weight: bold;
}
.new-employee-select .input {
  height: 45px !important;
  width: 100%;
  border-radius: 8px !important;
  border: 1px solid #CBD5E1 !important;
  margin: 0 !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
  cursor: pointer;
}
.new-employee-select .input input {
  border: none;
  border-radius: 0;
  margin: 0;
}
.new-employee-select .input.required {
  border-left: 4px solid #7A6BE8 !important;
}
.new-employee-select .input.no-required {
  border-left: 4px solid #465568 !important;
}
.new-employee-select .input.error {
  border: 1px solid #ec6376 !important;
  border-left: 4px solid #ec6376 !important;
}
.new-employee-select .input:disabled {
  opacity: 0.5;
}
.new-employee-select input:disabled ~ label {
  opacity: 0.5;
}
.new-employee-select ul {
  position: absolute;
  top: 75px;
  border: 1px solid #CBD5E1;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  background: white;
  width: 100%;
  border-radius: 10px;
  padding: 10px 0;
  list-style: none;
  z-index: 9999;
  max-height: 300px;
  overflow-y: auto;
}
.new-employee-select ul li {
  padding: 5px 15px;
  width: 100%;
  cursor: pointer;
}
.new-employee-select ul li:hover {
  background: rgba(122, 107, 232, 0.1333333333);
}

.button-new-employee button:disabled {
  background: #F1F4F9;
  border: none;
  color: #64748B;
}

.new-employee-select-disabled {
  margin: 5px 0;
  display: flex;
  flex-direction: column-reverse;
  position: relative;
  opacity: 0.5;
}
.new-employee-select-disabled label {
  font-size: 14px;
  font-weight: bold;
}
.new-employee-select-disabled .input {
  height: 45px !important;
  width: 100%;
  border-radius: 8px !important;
  border: 1px solid #CBD5E1 !important;
  margin: 0 !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
  border-left: 4px solid #7A6BE8 !important;
}
.new-employee-select-disabled .input input {
  border: none;
  border-radius: 0;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/Components/Employee/Select_Required/select.sass"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;AACD;AACC;EACC,eAAA;EACA,iBAAA;AACF;AACC;EACC,uBAAA;EACA,WAAA;EACA,6BAAA;EACA,oCAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;AACF;AACE;EACC,YAAA;EACA,gBAAA;EACA,SAAA;AACH;AAEE;EACC,yCAAA;AAAH;AAEE;EACC,yCAAA;AAAH;AAEE;EACC,oCAAA;EACA,yCAAA;AAAH;AAEE;EACC,YAAA;AAAH;AAEC;EACC,YAAA;AAAF;AAEC;EACC,kBAAA;EACA,SAAA;EACA,yBAAA;EACA,2CAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AAAF;AAEE;EACC,iBAAA;EACA,WAAA;EACA,eAAA;AAAH;AAEG;EACC,6CAAA;AAAJ;;AAGC;EACC,mBAAA;EACA,YAAA;EACA,cAAA;AAAF;;AAGA;EACC,aAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,YAAA;AAAD;AAEC;EACC,eAAA;EACA,iBAAA;AAAF;AAEC;EACC,uBAAA;EACA,WAAA;EACA,6BAAA;EACA,oCAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,yCAAA;AAAF;AAEE;EACC,YAAA;EACA,gBAAA;EACA,SAAA;AAAH","sourcesContent":[".new-employee-select\r\n\tmargin: 5px 0\r\n\tdisplay: flex\r\n\tflex-direction: column-reverse\r\n\tposition: relative\r\n\r\n\tlabel\r\n\t\tfont-size: 14px\r\n\t\tfont-weight: bold\r\n\r\n\t.input\r\n\t\theight: 45px !important\r\n\t\twidth: 100%\r\n\t\tborder-radius: 8px !important\r\n\t\tborder: 1px solid #CBD5E1 !important\r\n\t\tmargin: 0 !important\r\n\t\tdisplay: flex\r\n\t\talign-items: center\r\n\t\tjustify-content: space-between\r\n\t\tpadding: 5px\r\n\t\tcursor: pointer\r\n\r\n\t\tinput\r\n\t\t\tborder: none\r\n\t\t\tborder-radius: 0\r\n\t\t\tmargin: 0\r\n\t\t\t\r\n\r\n\t\t&.required\r\n\t\t\tborder-left: 4px solid #7A6BE8 !important\r\n\r\n\t\t&.no-required\r\n\t\t\tborder-left: 4px solid #465568 !important\r\n\t\t\r\n\t\t&.error\r\n\t\t\tborder: 1px solid #ec6376 !important\r\n\t\t\tborder-left: 4px solid #ec6376 !important\r\n\r\n\t\t&:disabled\r\n\t\t\topacity: 0.5\r\n\r\n\t& input:disabled ~ label\r\n\t\topacity: .5\r\n\r\n\t& ul\r\n\t\tposition: absolute\r\n\t\ttop: 75px\r\n\t\tborder: 1px solid #CBD5E1\r\n\t\tbox-shadow: 0px 2px 8px rgba(0,0,0,.15)\r\n\t\tbackground: white\r\n\t\twidth: 100%\r\n\t\tborder-radius: 10px\r\n\t\tpadding: 10px 0\r\n\t\tlist-style: none\r\n\t\tz-index: 9999\r\n\t\tmax-height: 300px\r\n\t\toverflow-y: auto\r\n\r\n\t\t& li\r\n\t\t\tpadding: 5px 15px\r\n\t\t\twidth: 100%\r\n\t\t\tcursor: pointer\r\n\r\n\t\t\t&:hover\r\n\t\t\t\tbackground: #7A6BE822\r\n\r\n.button-new-employee\r\n\tbutton:disabled\r\n\t\tbackground: #F1F4F9\r\n\t\tborder: none\r\n\t\tcolor: #64748B\r\n\r\n\r\n.new-employee-select-disabled\r\n\tmargin: 5px 0\r\n\tdisplay: flex\r\n\tflex-direction: column-reverse\r\n\tposition: relative\r\n\topacity: .5\r\n\r\n\tlabel\r\n\t\tfont-size: 14px\r\n\t\tfont-weight: bold\r\n\r\n\t.input\r\n\t\theight: 45px !important\r\n\t\twidth: 100%\r\n\t\tborder-radius: 8px !important\r\n\t\tborder: 1px solid #CBD5E1 !important\r\n\t\tmargin: 0 !important\r\n\t\tdisplay: flex\r\n\t\talign-items: center\r\n\t\tjustify-content: space-between\r\n\t\tpadding: 5px\r\n\t\tborder-left: 4px solid #7A6BE8 !important\r\n\t\t\r\n\t\tinput\r\n\t\t\tborder: none \r\n\t\t\tborder-radius: 0\r\n\t\t\tmargin: 0 "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
